import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GetCartItems, RemoveItemFromCart } from "../Data";
import { Global } from "../Variables/Global";
import { BsTrash } from "react-icons/bs";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import "./Cart.css";

const Cart = () => {
	const [cartItems, setCartItems] = useState([]);
	const [cartCount, setCartCount] = useState(0);
	const [delivery] = useState(30);

	const token = Cookies.get("CustomerToken");
	const navigate = useNavigate();
	const isArabic = window.location.pathname.startsWith("/AR");

	const GetItemsCart = () => {
		const CartId = Cookies.get("Cart");
		if (!CartId) return;

		const groupId = Cookies.get("WishList") ? 4 : 3;

		GetCartItems(CartId, groupId, token).then(result => {
			setCartItems(result.CartItems || []);
			setCartCount(result.Count || 0);
		});
	};

	const getItemPrice = item =>
		item.SalePrice > 0 ? item.SalePrice : item.RegularPrice;

	const getSubtotal = item =>
		getItemPrice(item) * item.Quantity;

	const getTotal = () =>
		cartItems.reduce((sum, i) => sum + getSubtotal(i), 0);

	const HandleRemove = ProductVariationId => {
		const CartId = Cookies.get("Cart");

		RemoveItemFromCart(ProductVariationId, CartId, token)
			.then(r => {
				if (!r.ok) throw new Error();
				toast.success("Item removed");
				GetItemsCart();
			})
			.catch(() => toast.error("Could not remove item"));
	};

	useEffect(() => {
		if (!token) navigate("/Authentication");
		GetItemsCart();
	}, []);

	return (
		<>
			{/* Breadcrumb */}
			<nav className="breadcrumb-wrapper">
				<div className="container">
					<ol className="breadcrumb-list">
						<li className="breadcrumb-item">
							<Link to="/" className="breadcrumb-link">
								<i className="fa fa-home"></i>
								<span>Home</span>
							</Link>
						</li>
						<li className="breadcrumb-separator">/</li>
						<li className="breadcrumb-item active">
							Cart
						</li>
					</ol>
				</div>
			</nav>

			<div className="container cart-page">
				{/* CART TABLE */}
				<div className="cart-table-wrapper">
					<table className="cart-table">
						<thead>
							<tr>
								<th>Product</th>
								<th>Details</th>
								<th>Price</th>
								<th>Qty</th>
								<th>Total</th>
								<th></th>
							</tr>
						</thead>

						<tbody>
							{cartItems.map((item, index) => {
								const name = isArabic
									? item.ProductNameAR || item.ProductName
									: item.ProductName;

								const image =
									item.Image
										? Global.PHOTO_URL + item.Image
										: "/assets/images/placeholder.png";

								return (
									<tr key={index}>
										<td className="product-image">
											<img src={image} alt={name} />
										</td>

										<td className="product-info">
											<h4>{name}</h4>

											{item.assignedAttributes?.length > 0 && (
												<ul className="attributes">
													{item.assignedAttributes.map((a, i) => (
														<li key={i}>
															<strong>{a.AttributeName}:</strong>{" "}
															{a.AttributeValueName}
														</li>
													))}
												</ul>
											)}

											<small>SKU: {item.Sku}</small>
										</td>

										<td className="price">
											{item.SalePrice > 0 ? (
												<>
													<span className="sale">
														AED {item.SalePrice}
													</span>
													<span className="regular">
														AED {item.RegularPrice}
													</span>
												</>
											) : (
												<span>AED {item.RegularPrice}</span>
											)}
										</td>

										<td>{item.Quantity}</td>

										<td className="subtotal">
											AED {getSubtotal(item)}
										</td>

										<td>
											<button
												className="remove-btn"
												onClick={() =>
													HandleRemove(item.ProductVariationId)
												}
											>
												<BsTrash />
											</button>
										</td>
									</tr>
								);
							})}

							{cartItems.length === 0 && (
								<tr>
									<td colSpan="6" className="empty-cart">
										Your cart is empty
									</td>
								</tr>
							)}
						</tbody>
					</table>

					{/* SUMMARY */}
					<div className="cart-summary">
						<h3>Order Summary</h3>

						<div className="summary-row">
							<span>Subtotal</span>
							<span>AED {getTotal()}</span>
						</div>

						<div className="summary-row">
							<span>Delivery</span>
							<span>AED {delivery}</span>
						</div>

						<div className="summary-row total">
							<span>Total</span>
							<span>AED {getTotal() + delivery}</span>
						</div>

						<Link
							to="/Checkout"
							state={{ cartItems, cartCount }}
						>
							<button
								className="checkout-btn"
								disabled={cartCount === 0}
							>
								Proceed to Checkout
							</button>
						</Link>
					</div>

				</div>

			</div>
		</>
	);
};

export default Cart;
